import VueDropzone from 'vue2-dropzone'
import excelParser from '../../../../services/excel-parser'
import purchaseHistoryService from '../../../../services/provider/purchase-history'
import _ from 'lodash'

const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024

export default {
    components: {
        VueDropzone
    },
    data() {
        return {
            item: {},
            listHeader: [],
            isFileSelect: false,
            modalError: '',
            labelName: {
                po_number: 'PO Number',
                vendor: 'Vendor',
                manufacturer: 'Manufacturer *',
                vendor_item_number: 'Vendor Item Number',
                manufacturer_item_number: 'Manufacturer Item Number',
                hospital_item_number: 'Hospital Item Number',
                product_description: 'Product Description *',
                quantity: 'Quantity',
                ship_date: 'Ship Date',
                receiving_date: 'Receiving Date',
                invoice_number: 'Invoice Number',
                lot_number: 'Lot Number',
                udi: 'UDI',
                location: 'Location',
                po_date: 'PO Date *',
                manufacturer_part_number: 'Manufacturer Part Number',
                vendor_catalog_number: 'Vendor Catalogue Number',
                manufacturer_catalog_number: 'Manufacturer Catalog Number',
                item_number: 'Item Number',
                model_number: 'Model Number',
                sku: 'SKU',
                // catalog_number: 'Catalog Number',
                serial_number: 'Serial Number',
                ndc: 'NDC',
                gtin: 'GTIN',
                internal_item_number: 'Internal Item Number',
                custom_field_1: 'Custom Field 1',
                custom_field_2: 'Custom Field 2',
                custom_field_3: 'Custom Field 3'
            },
            dropzoneOptions: {
                url: '#',
                acceptedFiles: '.xlsx,.xls',
                maxFiles: 1,
                maxFilesize: 100,
                previewsContainer: false,
                autoProcessQueue: false
            }
        }
    },
    methods: {
        resetState() {
            this.item = {
                po_number: null,
                vendor: null,
                manufacturer: null,
                vendor_item_number: null,
                manufacturer_item_number: null,
                hospital_item_number: null,
                product_description: null,
                quantity: null,
                ship_date: null,
                receiving_date: null,
                invoice_number: null,
                lot_number: null,
                udi: null,
                location: null,
                po_date: null,
                manufacturer_part_number: null,
                vendor_catalog_number: null,
                manufacturer_catalog_number: null,
                // item_number: null,
                model_number: null,
                sku: null,
                // catalog_number: null,
                serial_number: null,
                ndc: null,
                gtin: null,
                internal_item_number: null,
                custom_field_1: null,
                custom_field_2: null,
                custom_field_3: null,
                file: null
            }
            this.listHeader = []
            this.isFileSelect = false
            this.modalError = ''
        },
        forceRerenderInsert() {
            this.resetState()
            this.$refs.modal.show()
        },
        getHeaderList(headers = []) {
            return headers.map(x => ({ value: x, text: x }))
        },
        async addSuccess(file) {
            this.resetState()

            if (!file || !file.name || !_.isArray(file.name.split('.'))) {
                return
            }

            const ext = file.name.split('.').pop().toLowerCase()
            if (!['xls', 'xlsx'].includes(ext)) {
                this.modalError = 'Only Excel files (.xlsx, .xls) are allowed.'
                return
            }

            if (file.size > MAX_FILE_SIZE_BYTES) {
                this.modalError = 'File size must not exceed 100 MB.'
                return
            }

            this.item.file = file
            try {
                const formData = new FormData()
                formData.append('file', this.item.file)
                const res = await excelParser.getExcelHeaders(formData)
                if (res.error) {
                    this.modalError = res.data?.m || 'Unable to read the file headers. Please try again.'
                    return
                }

                const headers = res.data?.d || []
                this.listHeader = this.getHeaderList(headers)
                this.isFileSelect = true
            } catch (e) {
                this.modalError = 'Unable to read the file headers. Please try again.'
            }
        },
        async save() {
            this.modalError = ''
            const isValid = await this.$refs.observer.validate()
            if (!isValid || !this.item.file) {
                return
            }

            const formData = new FormData()
            formData.append('manufacturer', this.item.manufacturer)
            formData.append('productDescription', this.item.product_description)
            formData.append('poDate', this.item.po_date)
            formData.append('poNumber', this.item.po_number || '')
            formData.append('vendor', this.item.vendor || '')
            formData.append('vendorItemNumber', this.item.vendor_item_number || '')
            formData.append('manufacturerItemNumber', this.item.manufacturer_item_number || '')
            formData.append('hospitalItemNumber', this.item.hospital_item_number || '')
            formData.append('quantity', this.item.quantity || '')
            formData.append('shipDate', this.item.ship_date || '')
            formData.append('receivingDate', this.item.receiving_date || '')
            formData.append('invoiceNumber', this.item.invoice_number || '')
            formData.append('lotNumber', this.item.lot_number || '')
            formData.append('udi', this.item.udi || '')
            formData.append('location', this.item.location || '')
            formData.append('manufacturerPartNumber', this.item.manufacturer_part_number || '')
            formData.append('vendorCatalogNumber', this.item.vendor_catalog_number || '')
            formData.append('manufacturerCatalogNumber', this.item.manufacturer_catalog_number || '')
            // formData.append('itemNumber', this.item.item_number || '')
            formData.append('modelNumber', this.item.model_number || '')
            formData.append('sku', this.item.sku || '')
            // formData.append('catalogNumber', this.item.catalog_number || '')
            formData.append('serialNumber', this.item.serial_number || '')
            formData.append('ndc', this.item.ndc || '')
            formData.append('gtin', this.item.gtin || '')
            formData.append('internalItemNumber', this.item.internal_item_number || '')
            formData.append('customField1', this.item.custom_field_1 || '')
            formData.append('customField2', this.item.custom_field_2 || '')
            formData.append('customField3', this.item.custom_field_3 || '')
            formData.append('file', this.item.file)

            try {
                const res = await purchaseHistoryService.uploadPOImportFile(formData)
                if (!res.error) {
                    this.$emit('onCompleted', 'UPDATE')
                    this.$refs.modal.hide()
                    return
                }
                this.modalError = res.data?.m || 'Failed to upload file. Please try again.'
            } catch (e) {
                this.modalError = e?.response?.data?.m || 'Failed to upload file. Please try again.'
            }
        },
    }
}
